var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "avue-crud",
        {
          ref: "crud",
          attrs: { option: _vm.option, data: _vm.list.value },
          on: { "refresh-change": _vm.refreshChange },
          scopedSlots: _vm._u([
            {
              key: "index",
              fn: function ({ row }) {
                return [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: row.index },
                      model: {
                        value: _vm.selectRow,
                        callback: function ($$v) {
                          _vm.selectRow = $$v
                        },
                        expression: "selectRow",
                      },
                    },
                    [_vm._v(" ")]
                  ),
                ]
              },
            },
            {
              key: "cdkeyNum",
              fn: function ({ row }) {
                return [
                  _c("span", { staticStyle: { color: "#409EFF" } }, [
                    row.generateType === 2
                      ? _c("span", [_vm._v("已生成：")])
                      : _vm._e(),
                    _c(
                      "span",
                      {
                        staticStyle: { color: "#409EFF", cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDetail(row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(row.cdkeyNum))]
                    ),
                  ]),
                ]
              },
            },
            {
              key: "menu",
              fn: function ({ row }) {
                return [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "ACTIVE_CODE_GENERATE_LOG",
                          expression: "'ACTIVE_CODE_GENERATE_LOG'",
                        },
                      ],
                      attrs: { type: "text", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.viewLog(row)
                        },
                      },
                    },
                    [_vm._v("日志")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "ACTIVE_CODE_GENERATE_EDIT",
                          expression: "'ACTIVE_CODE_GENERATE_EDIT'",
                        },
                      ],
                      attrs: { type: "text", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.edit(row)
                        },
                      },
                    },
                    [_vm._v("编辑")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "ACTIVE_CODE_GENERATE_DEL",
                          expression: "'ACTIVE_CODE_GENERATE_DEL'",
                        },
                      ],
                      attrs: { type: "text", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.del(row)
                        },
                      },
                    },
                    [_vm._v("删除")]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c("template", { slot: "mySearch" }, [
            _c(
              "div",
              { staticClass: "search-contain" },
              [_c("Search", { on: { exportActiveCode: _vm.exportCode } })],
              1
            ),
          ]),
        ],
        2
      ),
      _c("ElementPagination", {
        staticStyle: { "margin-bottom": "20px" },
        attrs: {
          "current-page": _vm.searchParams.current,
          "page-size": _vm.searchParams.size,
          total: _vm.searchParams.total,
          "page-sizes": [10, 20, 30, 40, 50],
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c("AuditDialog", {
        ref: "auditDialog",
        scopedSlots: _vm._u([
          {
            key: "submitFooter",
            fn: function (scope) {
              return [
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.submitAudit(scope)
                          },
                        },
                      },
                      [_vm._v("确认提交审核")]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "auditFooter",
            fn: function (scope) {
              return [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "column",
                      "align-items": "center",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "margin-bottom": "10px",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              width: "100px",
                              "margin-right": "10px",
                            },
                            attrs: { size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.auditPass(scope.id)
                              },
                            },
                          },
                          [_vm._v("审核通过")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: { width: "100px" },
                            attrs: { type: "primary", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.auditReject(scope.id)
                              },
                            },
                          },
                          [_vm._v("审核不通过")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c("el-input", {
                          staticClass: "auditOpinion",
                          attrs: {
                            maxlength: "999",
                            size: "small",
                            clearable: "",
                            placeholder: "审核意见",
                          },
                          model: {
                            value: _vm.auditOpinion,
                            callback: function ($$v) {
                              _vm.auditOpinion = $$v
                            },
                            expression: "auditOpinion",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _c("OptionLog", {
        ref: "optionLog",
        attrs: { columnConfig: _vm.optionLogColumn, closeBtn: false },
        on: { reload: _vm.reloadOpt },
        scopedSlots: _vm._u([
          {
            key: "type",
            fn: function ({ row }) {
              return [
                _c("div", [
                  row.type === 1 ? _c("span", [_vm._v("新增")]) : _vm._e(),
                  row.type === 2 ? _c("span", [_vm._v("修改")]) : _vm._e(),
                  row.type === 3 ? _c("span", [_vm._v("删除")]) : _vm._e(),
                  row.type === 4 ? _c("span", [_vm._v("提交审核")]) : _vm._e(),
                  row.type === 5 ? _c("span", [_vm._v("撤销审核")]) : _vm._e(),
                  row.type === 6 ? _c("span", [_vm._v("审核通过")]) : _vm._e(),
                  row.type === 7 ? _c("span", [_vm._v("审核拒绝")]) : _vm._e(),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("DetailDialog", { ref: "detail" }),
      _c("AddDialog", { ref: "add" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }